import(/* webpackMode: "eager" */ "/var/www/azia_frontv2_green/.local-data/work/footer-width-a9eaccc59f13c3da08aa8ad89c6d451f85570c72/build/src/app/global-error.tsx");
